import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import "../css/WishlistPage.css";

const WishlistPage = ({ onClose }) => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const contentRef = useRef();

  const handleOverlayClick = (e) => {
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      onClose(); // Closes modal when clicking outside
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/");
      return;
    }

    const user = JSON.parse(storedUser);

    axios
      .get(`http://localhost:8080/api/wishlist/${user.id}`)
      .then((response) => {
        setWishlist(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to load wishlist", error);
        setLoading(false);
      });
  }, [navigate]);

  return (
    <div className="wishlist-overlay" onClick={handleOverlayClick}>
      <div className="wishlist-content" ref={contentRef}>
        <Button variant="danger" className="close-btn" onClick={onClose}>
          &times;
        </Button>
        <h3 className="text-center mb-4">My Wishlist</h3>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : wishlist.length === 0 ? (
          <p className="text-center">Your wishlist is empty.</p>
        ) : (
          <Row>
            {wishlist.map((trip) => (
              <Col md={4} key={trip.id} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Img
                    variant="top"
                    src={trip.imageUrl}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>{trip.title}</Card.Title>
                    <Card.Text>
                      {trip.originalPrice && (
                        <del>
                          ₹{Number(trip.originalPrice).toLocaleString()}
                        </del>
                      )}{" "}
                      <strong>₹{Number(trip.price).toLocaleString()}</strong>
                    </Card.Text>
                    <Card.Text>⏳ {trip.duration}</Card.Text>
                    <Link
                      to={`/trips/${trip.path}`}
                      className="btn btn-dark btn-sm w-100"
                      onClick={onClose}
                    >
                      View Trip
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
